export enum ProfileRoutes {
  EDIT = 'edit',
  CONTACT = 'contact',
  WHATS_NEW = 'whats-new'
}
